import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 10px;
  height: 5.998px;
  margin-right: 0.5rem;
`;

const TreeExpandIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.028L1.034.004 5 3.956 8.965.004 10 1.028l-5 4.97z" fill="#0076ce" />
    </Svg>
  );
};

export default TreeExpandIcon;
